import { css, styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
export const Container = styled.div.withConfig({
  displayName: "DateInputstyles__Container",
  componentId: "sc-1i39wma-0"
})(["position:relative;width:", ";display:flex;flex-direction:column;"], ({
  fullWidth,
  expand
}) => {
  if (expand) {
    return '100%';
  }
  if (fullWidth) {
    return 'calc(50vw - 1px)';
  }
  return '173px';
});
export const prefixedIconStyle = css`
  position: absolute;
  left: 16px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 24px;
  color: ${Colors.GREY_d2d2d2};
  pointer-events: none;
  z-index: 20;
`;
export const CalendarIconContainer = styled.div.withConfig({
  displayName: "DateInputstyles__CalendarIconContainer",
  componentId: "sc-1i39wma-1"
})(["", ";"], prefixedIconStyle);
export const dateContainerStyle = css`
  ${props => props.inputStyle === 'RangeLeft' && css`
      margin-right: -0.5px;
    `}

  ${props => props.inputStyle === 'RangeRight' && css`
      margin-left: -0.5px;
    `}
`;
export const dateInputStyle = css`
  ${Fonts.regular(16)};
  padding: 14px;
  padding-left: ${props => props.showPrefixIcon ? '50px' : '14px'};
  line-height: 20px;
  border: solid 1px ${props => props.showError ? Colors.ERROR : Colors.GREY_969696};
  z-index: ${props => props.showError ? 5 : 0};
  border-radius: 2px;
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  font-variant-numeric: tabular-nums;
  color: ${props => props.disabled ? Colors.GREY_969696 : Colors.GREY_d2d2d2};
  background-color: ${Colors.GREY_1a1a1a};

  &:focus {
    outline: 0;
    border: solid 1px ${props => props.showError ? Colors.ERROR : Colors.GREY_d2d2d2};
    color: ${Colors.GREY_e1e1e1};
    z-index: 2;
  }

  ${props => props.inputStyle === 'RangeLeft' && css`
      border-radius: 2px 0 0 2px;
    `}

  ${props => props.inputStyle === 'RangeRight' && css`
      border-radius: 0 2px 2px 0;
    `}
`;
export const Input = styled.input.withConfig({
  displayName: "DateInputstyles__Input",
  componentId: "sc-1i39wma-2"
})(["", ";padding-right:", ";"], dateInputStyle, props => props.hasText ? '32px' : '14px');
export const ResetButton = styled.button.withConfig({
  displayName: "DateInputstyles__ResetButton",
  componentId: "sc-1i39wma-3"
})(["position:absolute;right:1px;top:2px;height:calc(100% - 4px);padding-right:10px;padding-left:3px;display:flex;align-items:center;font-size:24px;color:", ";z-index:10;&:hover{color:", ";}"], props => props.showError ? Colors.ERROR : Colors.GREY_d2d2d2, props => props.showError ? Colors.ERROR : Colors.GREY_e1e1e1);